import { InfoCircleOutlined } from "@ant-design/icons";
import { IBriefCampaignBriefInfluencer } from "@shared/lib/types/briefCampains";
import { IBriefInfluencerV2 } from "@shared/lib/types/briefInfluencerV2";
import { Popover } from "antd";
import { BriefTimeline } from "./BriefTimline";

export function BriefTimelinePopOver({
  briefInfluencer,
  type,
}: {
  briefInfluencer: IBriefInfluencerV2 | IBriefCampaignBriefInfluencer;
  type: "brand" | "influencer";
}) {
  const timeline = briefInfluencer.timeline;
  const brandTimeLine = briefInfluencer.brandTimeLine;

  const getIconColor = () => {
    if (type === "influencer") {
      const infOfferStatus = briefInfluencer.offerStatus;
      if (!infOfferStatus) {
        return "#B9B9B9";
      } else if (infOfferStatus === "offer-accepted") {
        return "black";
      } else if (infOfferStatus === "negotiations-requested") {
        return "#ffcc00";
      } else if (infOfferStatus === "negotiations-accepted") {
        return "#007AFF";
      }
      return "#B9B9B9";
    } else if (type === "brand") {
      const brandOfferStatus = briefInfluencer.brandCostStatus;
      if (!brandOfferStatus) {
        return "#B9B9B9";
      } else if (brandOfferStatus === "First-Quote-Recieved") {
        return "black";
      } else if (brandOfferStatus === "Negotiations-Requested") {
        return "#ffcc00";
      } else if (brandOfferStatus === "New-Quote-Recieved") {
        return "#007AFF";
      }

      return "#B9B9B9";
    }
  };
  return (
    <Popover
      placement="left"
      content={
        <BriefTimeline
          timeline={timeline}
          brandTimeLine={brandTimeLine}
          type={type}
        />
      }
    >
      <InfoCircleOutlined style={{ fontSize: 12, color: getIconColor() }} />
    </Popover>
  );
}
